import env from '@upgrade/ui-utils/env';
import { isUniversalCreditHostname } from '@upgrade/ui-utils/utils/theme';
import { UNIVERSAL_CREDIT_PREFIX } from '../constants/universal-credit';
export var getPrefixedKey = function getPrefixedKey(key) {
  var isUniversalCredit = isUniversalCreditHostname(env);
  return "".concat(isUniversalCredit ? UNIVERSAL_CREDIT_PREFIX : '').concat(key);
};